import React, { useRef, useEffect } from 'react';
import { Spinner } from 'ui';
import { createPlayerElement, withZiggeo } from './ziggeoHelpers';

const ZiggeoVideoPlayer = ({ token, className }) => {
  const playerRef = useRef(null);

  const setAccessibilityAttributes = () => {
    const { current: playerElement } = playerRef;
    const thumbnail = playerElement.querySelector('img.ba-videoplayer-video');
    if (thumbnail) {
      thumbnail.setAttribute(
        'alt',
        t('practice.practice_feedback.feedback_overview.feedback'),
      );
    }
  };
  useEffect(() => {
    if (playerRef.current) {
      createPlayerElement(token, null, playerRef.current);
      setAccessibilityAttributes();
    }
  }, [token]);
  return (
    <div ref={playerRef} className={`${className} m-mh-a`}>
      <div className="d-f ai-c jc-c p-24 m-mh-a iframe-16-9">
        <Spinner size="larger" />
      </div>
    </div>
  );
};

export default withZiggeo(ZiggeoVideoPlayer);
